class DZModelAddress{

    /**
     * 主键
     */
    id = "";

    /**
     *省份ID
     */
    provinceId = "";

    /**
     *省份名称
     */
    provinceName = "";

    /**
     *城市ID
     */
    cityId = "";

    /**
     *城市名称
     */
    cityName = "";

    /**
     *区县ID
     */
    countyId = "";

    /**
     *区县名称
     */
    countyName = "";

    countyArr = []
    /**
     *详细地址
     */
    addressInfo = "";

    /**
     *坐标经度
     */
    lng = "";

    /**
     *坐标纬度
     */
    lat = "";

    /**
     * 更新用户ID
     */
    updateBy = "";

    /**
     * 更新时间
     */
    updateTime = "";

    /**
     * 发布用户ID
     */
    createBy = "";

    /**
     * 创建时间
     */
    createTime = "";
}
export default DZModelAddress